
 
 
 (function ($) { 

	 Drupal.behaviors.standardVideo = {
			    attach: function (context) {
			    		Drupal.behaviors.standardVideoCreator(context);
			    }
	}
	  Drupal.behaviors.standardVideoCreator = function (context){
			$(".standardVideo", context).each(function (index){
			    	var isAlreadyModified = $(this).data("saph-done");
			    	if(isAlreadyModified){
			    		return true;
			    	}

					if($(this).hasClass("videoInline")){
						//no layer handling
						return true;
					}

				Drupal.behaviors.linkButtonCreator($(this));
				

				$(this).find(".videoOverlay").click(function(){
					var iframeSrc = $(this).attr("data-video-link");
					//var iframe = $(this).siblings("iframe");
					//iframe.attr("src", iframeSrc);
					//iframe.show();

					$(this).addClass("videoOverlayActive");

					$(".standardVideoDetail").find("iframe").attr("src", iframeSrc);
					
					$(".standardVideoDetail").find("iframe").show();
					$(".standardVideoDetail").css("opacity", 1);
					$(".standardVideoDetail").show();	
					
					/*
					$(".standardVideoDetail").find("iframe").css("opacity", 0);					
					$(".standardVideoDetail").css("opacity", 0);
					$(".standardVideoDetail").show();					
					$(".standardVideoDetail").fadeTo(500, 1, function() {
						$(".standardVideoDetail").find("iframe").css("opacity", 1);
					});
					*/

					$(".standardVideoDetail").find(".standardVideoDetailVideo").children(".content").css("background-image", "url('"+ $(this).siblings("img").attr("src") +"')");

					/*
					$(window).unbind("scroll", handleScroll);
					var ie = Drupal.behaviors.functions.detectIE();
					Drupal.behaviors.functions.consolog("VIDEO ie:" + ie);
                    if(ie && ie <= 11){						
						//no scroll listener for IE 11
					}
					else{
						$(window).bind("scroll", handleScroll);	
					}
					*/

					$(this).siblings("img").fadeTo(500, 0, function() {
						
					});
					
					$(".standardVideoDetail").unbind().click(closeVideoDetail);

				});
				$(this).data("saph-done",true);
			});

			function handleScroll(){
				if(window.innerHeight == screen.height) {
					Drupal.behaviors.functions.consolog('Browser is in fullscreen');
				}
				else{
					closeVideoDetail();
				}
			}

			function closeVideoDetail(){

				$(window).unbind("scroll", closeVideoDetail);

				//scroll page to video preview
				$('html, body').animate({scrollTop:$(".videoOverlayActive").offset().top-100},500);

				//fade in video preview image
				$(".videoOverlayActive").siblings("img").fadeTo(500, 1, function() {

				});
				
				$(".videoOverlayActive").removeClass("videoOverlayActive");

				//fade out video layer
				$(".standardVideoDetail").fadeTo(500, 0, function() {
					$(".standardVideoDetail").hide();
					$(".standardVideoDetail").find("iframe").attr("src", "");
					
				});
			}
	  }  
	  

})(jQuery); 